/* tslint:disable:max-line-length */
import React, { useEffect } from 'react';
import { Template } from './Template';
import { Routes } from '../../routes/top-level-routes';
import { Link } from '@mm/components';

export const PrivacyPolicy = () => (
  <div>
    <h1 style={{ marginBottom: '13px' }}>Customers.ai Inc Privacy Policy</h1>
    <p>
      <strong>Effective date: November 28, 2017</strong>
      <br />
      We at Customers.ai, Inc. (“Customers.ai Inc.”, “we” or “us”) take privacy
      seriously and are constantly striving to provide excellent service to you
      while building a long-lasting relationship with you.
    </p>

    <p>
      If you are a member of the EU:{' '}
      <Link to={Routes.euSpecificPolicy.path}>
        Customers.ai’s EU-Specific Privacy Policy
      </Link>
    </p>

    <p>
      We respect the privacy of our users and have developed this privacy policy
      (the “Privacy Policy”) to articulate its commitment to protecting your
      privacy. The Privacy Policy is intended to describe for you, as an
      individual who is a user of our Application or of the services offered
      through the Application (collectively with the Application, the
      “Services”), the information we collect, how that information may be used,
      with whom it may be shared, and your choices about such uses and
      disclosures.
    </p>

    <p>
      Our goal is to provide you with a personalized online experience that
      provides you with the information, resources, and services that are most
      relevant and helpful to you. We encourage you to read this Privacy Policy
      carefully when using the Services. By accessing the Services, you
      acknowledge and agree that you have read, fully accept, and will abide by
      this Privacy Policy.
    </p>

    <p>
      <strong>What does this Privacy Policy cover?</strong>
      <br />
      This Privacy Policy covers our treatment of personally identifiable
      information (“Personal Information”) that we gather when you are accessing
      or using our Services, but not to the practices of companies we don’t own
      or control, or people that we don’t manage.
    </p>

    <p>
      We gather various types of Personal Information from our users, as
      explained in more detail below, and we use this Personal Information
      internally in connection with our Services, including to personalize,
      provide, and improve our services, to allow you to set up a user account,
      to enable you to build chatbots and communicate with chatbots others have
      built, to contact you and allow other users to contact you, to fulfill
      your requests for certain products and services, and to analyze how you
      use the Services. In certain cases, we may also share some Personal
      Information with third parties, but only as described below.
    </p>

    <p>
      <strong>Children’s Policy</strong>
      <br />
      As noted in the Terms of Use, we do not knowingly collect or solicit
      personal information from anyone under the age of 13. If you are under 13,
      please do not attempt to register for the Services or send any personal
      information about yourself to us. If we learn that we have collected
      personal information from a child under age 13, we will delete that
      information as quickly as possible. If you believe that a child under 13
      may have provided us personal information, please contact us at
      tos@Customers.ai.
    </p>

    <p>
      <strong>Will Customers.ai ever change this Privacy Policy?</strong>
      <br />
      Customers.ai, Inc. is a company that continues to develop new products
      including additions to our application to create bots (the “Application”)
      operated by Customers.ai, Inc., As a result our Services are under
      continuous development and some parts of this Privacy Policy may refer to
      functions of the Services that have not yet been implemented or deployed.
      Once such functions are available for use, by accessing and continuing to
      use the Services thereafter, you agree that those parts of the Privacy
      Policy shall go into effect.
    </p>

    <p>
      We may need to at some point in the future, modify this Privacy Policy by
      posting a new Policy at this site and noting the date upon which the new
      policy is effective and/or by sending you an email with the new terms.
      Please review the changes to our Policy carefully. If you agree to the
      terms, simply continue to use the services offered at our site. If you
      object to any of the changes to the Privacy Policy, please do not continue
      to use our services, as your continued use of the services after we’ve
      posted a notice of changes to the Privacy Policy shall constitute your
      consent to the changed terms or practices.
    </p>

    <p>
      <strong>What Information does Customers.ai Collect?</strong>
      <br />
      <strong>Information You Provide to Us:</strong>
      <br />
      We receive and store information you knowingly provide to us. For example,
      if you create an account on our Services to build a chatbot, through the
      registration process and/or through your account settings, we may collect
      Personal Information such as, but not limited to, your name, email
      address, timezone, list of Facebook Pages you own. Or, if you are an
      individual who communicates with chatbots that have been created using our
      services, we may collect information such as, but not limited to, your
      name, gender, time zone, and avatar/picture. If you provide your Facebook
      or other third-party account credentials to, you understand some content
      and/or information in those accounts (“Third Party Account Information”)
      may be transmitted into your account with us, and that Third Party Account
      Information transmitted to our Services is covered by this Privacy Policy;
      for example, when you log in to our Services using your Facebook Messenger
      account, we may receive your personal information associated with that
      account, such as your Facebook pages. Certain information may be required
      to register with us or to take advantage of some of our features.
    </p>

    <p>
      <strong>Information Collected Automatically</strong>
      <br />
      Whenever you interact with our Services, we automatically receive and
      record information on our server logs from your browser or device, which
      may include any chatbots you have created using the Services, your
      conversation history with the chatbots(s), IP address, geolocation data,
      device identification, “cookie” information, the type of browser and/or
      device you’re using to access our Services, and the page or feature you
      requested. “Cookies” are identifiers we transfer to your browser or device
      that allow us to recognize your browser or device and tell us how and when
      pages and features in our Services are visited and by how many people. You
      may be able to change the preferences on your browser or device to prevent
      or limit your device’s acceptance of cookies, but this may prevent you
      from taking advantage of some of our features. If you click on a link to a
      third party website or service, a third party may also transmit cookies to
      you. Again, this Privacy Policy does not cover the use of cookies by any
      third parties, and we aren’t responsible for their privacy policies and
      practices. Please be aware that cookies placed by third parties may
      continue to track your activities online even after you have left our
      Services, and those third parties may not honor “Do Not Track” requests
      you have set using your browser or device. We may use this data to
      customize content for you that we think you might like, based on your
      usage patterns. We may also use it to improve the Services or to help
      developers build better chatbots– for example, this data can tell us how
      often users use a particular feature of the Services, or what kinds of
      questions users ask of certain chatbots, and we can use that knowledge to
      make the Services and the chatbots created through the Services
      interesting to as many users as possible.
    </p>

    <p>
      <strong>
        Information Collected from Other Websites and Do Not Track Policy
      </strong>
      <br />
      Through cookies we place on your browser or device, we may collect
      information about your online activity after you leave our Services. Just
      like any other usage information we collect, this information allows us to
      improve the Services and customize your online experience, and otherwise
      as described in this Privacy Policy. Your browser may offer you a “Do Not
      Track” option, which allows you to signal to operators of websites and web
      applications and services (including behavioral advertising services) that
      you do not wish such operators to track certain of your online activities
      over time and across different websites. Our Services do not support Do
      Not Track requests at this time.
    </p>

    <p>
      <strong>
        Sharing Information with Partners, Affiliates, Resellers and Chatbot
        “owners”
      </strong>
      <br />
      Customers.ai does not distribute personal information that you have shared
      with us, except as permitted in this Privacy Policy and our then-current
      Terms of Use, if any.
    </p>

    <p>
      Customers.ai may share your name, address, email, and other contact
      information with certain of our partners, affiliates, and resellers who we
      think may have offers, products, or services that may be of value to you.
      We will not provide our partners with any credit card, billing information
      or history or personal information that we have gained through our
      relationship that is not relevant to the partners primary business
      function and offer. We may also send you information on products,
      services, or offers by third parties that we think you might find valuable
      to you. Our partners, affiliates, and resellers also may use the contact
      information you’ve provided us to contact you directly with information on
      their own products, services, and offers. By providing us with your
      personal information during the user registration process and by accessing
      our site and our services, you are agreeing to the terms of this Privacy
      Policy, and you expressly consent to our storing, processing, and
      distributing your information for these purposes.
    </p>

    <p>
      Customers.ai also may disclose personal information that is associated
      with your profile as permitted by law or as reasonably necessary to: (1)
      comply with a legal requirement or process, including, but not limited to,
      civil and criminal subpoenas, court orders or other compulsory
      disclosures; (2) investigate and enforce this Privacy Policy or our
      then-current Terms Use, if any; (3) respond to claims of a violation of
      the rights of third parties; (4) respond to customer service inquiries;
      (5) protect the rights, property, or safety of Customers.ai, our users, or
      the public; or (6) as part of the sale of the assets of Customers.ai or as
      a change in control of the organization or one of its affiliates or in
      preparation for any of these events. Customers.ai reserves the right to
      supply any such information to any organization into which Customers.ai
      may merge in the future or to which it may make any transfer. Any third
      party to which Customers.ai transfers or sells its assets will have the
      right to use the personal and other information that you provide in the
      manner set out in this Privacy Policy.
    </p>

    <p>
      Chatbot “Owners”: The creators and distributors of chatbots are the
      “owners” of the chatbots created through the Services which you
      communicate with will have access to the Personal Information you provide
      to them. For example, if you communicate with a chatbot which was created
      through the Services, the developer/owner of that chatbot may have access
      to your conversation history with the chatbot, your username, your avatar,
      and any other information you provide through the chatbot. In addition,
      the chatbot creator/owner may use a variety of third party product
      integration to receive and process the data from your interaction with the
      chatbot.
      <br />
      Note: Customers.ai is not responsible and cannot be held liable for the
      use of personal information gathered during chatbot session and collected
      by a chatbot “owner”.
    </p>

    <p>
      <strong>Links to Third Party Websites and Services</strong>
      <br />
      Customers.ai’s website and services may provide links to third-party
      websites for the convenience of our users. If you access those links, you
      will leave Customers.ai’d website. Customers.ai does not control these
      third-party websites and cannot represent that their policies and
      practices will be consistent with this Privacy Statement. For example,
      other websites may collect or use personal information about you in a
      manner different from that described in this document. Therefore, you
      should use other websites with caution, and you do so at your own risk. We
      encourage you to review the privacy policy of any website before
      submitting personal information.
    </p>

    <p>
      <strong>Communications from Customers.ai</strong>
      <br />
      We use the information you provide to customize your experience on our
      sites and our services. We may communicate with you using email or other
      means available to us regarding the availability of services,
      service-related issues, or promotional messages that we believe may be of
      interest to you. We may, for example, send you welcome messages, emails
      regarding new features or services, targeted advertisements, and other
      promotional information from Customers.ai, or our affiliates, members, and
      partners. You may opt out of receiving promotional messages from
      Customers.ai by following the instructions contained in the email. As long
      as you’re a registered user, however, you can’t opt out of receiving
      service messages from us. Customers.ai may also use personal information
      in order to customize content on the site to you, such as news relevant to
      you or to your industry or to Customers.ai.
    </p>

    <p>
      <strong>How we protect your personal information</strong>
      <br />
      We take appropriate security measures (including physical, electronic and
      procedural measures) to help safeguard your personal information from
      unauthorized access and disclosure. For example, only authorized employees
      and third parties who have agreed to be bound by confidentiality
      restrictions, such as consultants, may be permitted to access personal
      information, and they may do so only for permitted business functions. In
      addition, we use SSL encryption in the transmission of your sensitive
      personal information between your system and ours, and we use firewalls to
      help prevent unauthorized persons from gaining access to your personal
      information. We want you to feel confident using the Services. However, no
      system can be completely secure. Therefore, although we take steps to
      secure your information, we do not promise, and you should not expect,
      that your personal information, searches, or other communications will
      always remain secure. Users should also take care with how they handle and
      disclose their personal information and should avoid sending personal
      information through insecure e-mail. Please refer to the Federal Trade
      Commission’s website at http://www.ftc.gov/bcp/menus/consumer/data.shtm
      for information about how to protect yourself against identity theft.
    </p>

    <p>
      Under California Civil Code Sections 1798.83-1798.84, California residents
      are entitled to contact us to prevent disclosure of Personal Information
      to third parties for such third parties’ direct marketing purposes; in
      order to submit such a request, please contact us at tos@Customers.ai.
    </p>

    <p>
      <strong>YOUR OPTIONS AND OBLIGATIONS</strong>
      <br />
      Rights to Access, Correct, or Delete Your Information; Closing Your
      Account.
      <br />
      You can always opt not to disclose information to us, but keep in mind
      some information may be needed to register with us, to communicate with
      chatbots, or to take advantage of some of our features. You may stop using
      the Services at any time; however, your conversation logs from
      communications with chatbots may remain in our records.
    </p>

    <p>
      By agreeing to this Privacy Policy you are should be fully aware that
      communication over a “chat” managed by any third party company including
      Customers.ai Inc should not be considered private and transcripts of the
      conversations will likely exist in several locations immediately upon
      submission. For example, a conversation over FaceBook Messenger will be
      stored within the Messenger platform (subject to the FaceBook privacy
      policy), stored within Customers.ai (subject to this privacy policy) and
      stored by the chatbot “owner” who you are communicating with.
    </p>

    <p>
      <strong>What if I have questions about this policy?</strong>
      <br />
      If you have any questions or concerns regarding our privacy policies,
      please send us a detailed message to TOS@customers.ai and we will try to
      address your concerns.
    </p>
  </div>
);

export const PrivacyPolicyPage = () => {
  useEffect(() => {
    window.location.href = 'https://customers.ai/privacy-policy';
  }, []);

  return null;
};
